<template>
	<div>
		<div class="row slim-grid-row pb-3" :class="module == 'laundry' && module_type == 'pcs'?'':'mb-2'">
	    <div class="col-3" v-if="module == 'room-dining' || module == 'spa'">
	      <img :src="data.product_image_list.length == 0 ? data.product_image : data.product_image_list[0].image_url" class="w-100 rounded-10 w-65px object-fit w-100">
	    </div>
	    <div :class="module == 'extra-amenities' || module == 'laundry' || module == 'experience' || module == 'maintenance-request'? 'col-12' : 'col-9'">
	      <p v-if="module == 'room-dining' || module == 'experience' ||  module == 'extra-amenities'" class="mb-0 body-2 font-bold text-black text-truncate">
	      	{{data.variant_name == null ? data.product_name : `[${data.variant_name}] ${data.product_name}`}}
	      </p>
	      <template v-if="module == 'laundry'">
	      	<p v-if="module == 'laundry'" class="mb-0 body-2 font-bold text-black text-truncate">{{data.variant_name}}</p>
	        <p v-if="module_type == 'kilo' && data.notes != ''" class="mb-0 body-2">Note: {{data.notes}}</p>
	      	<template v-if="module_type == 'pcs'">
	      		<p class="mb-0 body-2 font-semibold">{{data.product_name}}</p>
	          <p v-if="data.notes != ''" class="mb-0 body-2">Note: {{data.notes}}</p>
	          <p class="mb-0 body-2-2 text-truncate d-inline-block font-semibold align-bottom mr-1">[{{data.qty}}x]</p>
	          <p class="mb-0 body-2-2 text-truncate d-inline-block font-semibold align-bottom">{{formatCurrency(data.price_sell)}}</p>
	      	</template>
	      </template>
	      <template v-if="module == 'spa'">
	      	<p class="mb-0 body-2 font-bold text-black text-truncate">
	      		{{data.product_name}}
	      	</p>
      	 	<p class="mb-0 body-2">Time: {{formatTime(data.service_date)}}</p>
          <p class="mb-0 body-2">{{data.qty}} Packages </p>
          <template v-if="data.remark != ''">
	          <p v-if="parsingRemark(data.remark,'Therapist gender') != ''" class="mb-0 body-2">Therapist: {{parsingRemark(data.remark,'Therapist gender')}}</p>
	          <p v-if="parsingRemark(data.remark,'Place choice') != ''" class="mb-0 body-2">Place: {{parsingRemark(data.remark,'Place choice')}}</p>
	          <p class="mb-0 body-2">Note: {{data.notes}}</p>
          </template>
	      </template>
	      <div v-if="module != 'laundry'" class="row slim-grid-row">
	      	<div class="col-12">
	      	</div>
	        <div class="col-12">
	        	<template v-if="module == 'room-dining' || module == 'experience' || module == 'extra-amenities'">
		          <p class="mb-0 body-2 font-semibold">{{data.product_category_name}}</p>
		          <p class="mb-0 body-2">Note: {{data.notes}}</p>
		          <p class="mb-0 body-2-2 text-truncate d-inline-block font-semibold align-bottom mr-1">[{{data.qty}}x]</p>
	        	</template>
	          <p class="mb-0 body-2-2 text-truncate d-inline-block font-semibold align-bottom">{{formatCurrency(data.price_sell)}}</p>
	        </div>
	      </div>
	    </div>
	  </div>
	</div>
</template>
<script>
	import {formatCurrency} from '@/utils/index.js'
	import moment from 'moment'
	export default{
		props:['data','module','module_type'],
		methods:{
			formatCurrency(price){
				return formatCurrency(price)
			},
			formatTime(date){
        return moment(date).format('HH:mm');
      },
      parsingRemark(data,index){
      	let split_1 = data.split(", ")
      	let callback = ''
      	for (let split_1_1 of split_1){
      		let split_2 = split_1_1.split(": ")
      		if(split_2[0] == index){
      			callback = split_2[1]
      		}
      	}
      	return callback
      }
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/hotel/concierge/general/historyDetailItem.vue